import axios from "axios";

export async function axiosRequest(options, errorHandler) {
	const contentType = options?.headers?.["Content-Type"];

	if (!options) {
		options = {};
	}

	if (!options.headers) {
		options.headers = {};
	}

	if(!contentType){
		options.headers["Content-Type"] = "application/json";
	} 
	
	return axios(options)
		.then(handleResponse)
		.catch(error => handleError(error, errorHandler));
}

export function handleResponse(response) {
	return Promise.resolve(response.data);
}

export function handleError(error, errorHandler) {
	if (errorHandler) {
		errorHandler(error);
	}

	const errorText = error.response ? error.response.data : error.message;
	return Promise.reject(errorText);
}